import { useState } from 'react';

import CustomIcon from '@components/utils/CustomIcon';

import { ShareItem, SocialText } from './style';

export const SocialItem = ({
  link,
  item,
  itemId,
  itemName,
  hotelListing,
  isFavoritesShare,
  listName,
}) => {
  const [hover, setHover] = useState(false);

  const { name, url, icon } = item;
  return (
    <ShareItem
      onClick={() =>
        isFavoritesShare
          ? dataLayer.push({
              event: 'ga4Event',
              event_name: 'list_share',
              share_platform: name,
              list_type:
                listName === 'Favorilerim' ? 'Favorilerim' : 'Custom List',
            })
          : dataLayer.push({
              event: 'ga4Event',
              event_name: 'product_share',
              share_platform: name,
              shared_from: hotelListing ? 'Listing' : 'Detail',
              product_name: itemName,
              product_id: itemId,
            })
      }
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      href={url(link)}
      data-action={`share/${name}/share`}
      rel='nofollow noopener noreferrer'
      target='_blank'
      className='share-icon'
      prefetch={false}
    >
      <CustomIcon
        icon={icon}
        fontSize={24}
        paletteColor={hover ? 'black' : 'D400'}
      />
      <SocialText>{name}</SocialText>
    </ShareItem>
  );
};
